import { toBnDigits } from '../../../../../utils/bnFormat';

/** A labelled range slider for one numeric setting — the label carries its current value. */
export default function SettingSlider({ id, label, value, min = 0, max = 100, disabled, onChange }) {
    return (
        <label htmlFor={id} className="block space-y-1.5">
            <span className="text-[12.5px] font-semibold text-zinc-800 dark:text-zinc-200">
                {label}
                {': '}
                {toBnDigits(value)}
            </span>
            <input
                id={id}
                type="range"
                min={min}
                max={max}
                value={value}
                disabled={disabled}
                onChange={(e) => onChange(Number(e.target.value))}
                className="w-full accent-amber-500"
            />
        </label>
    );
}
